import {Component, OnDestroy, OnInit} from '@angular/core';
import {Button} from 'primeng/button';
import {FormBuilder, FormGroup, FormsModule, ReactiveFormsModule, Validators} from '@angular/forms';
import {InputText} from 'primeng/inputtext';
import {Avatar} from 'primeng/avatar';
import {date} from '@primeuix/themes/aura/datepicker';
import {DynamicDialogConfig, DynamicDialogRef} from 'primeng/dynamicdialog';
import {FloatLabel} from 'primeng/floatlabel';
import {DialogAction} from '../../../../shared/contracts/dialog.interface';
import {NgIf} from '@angular/common';
import {TenantService} from '../../../services/tenant.service';

@Component({
  selector: 'kc-tenant-dialog',
  standalone: true,
  imports: [
    Button,
    FormsModule,
    InputText,
    Avatar,
    ReactiveFormsModule,
    FloatLabel,
    NgIf
  ],
  templateUrl: './tenant-dialog.component.html',
  styleUrl: './tenant-dialog.component.scss'
})
export class TenantDialogComponent implements OnDestroy, OnInit {

  constructor(private fb: FormBuilder, private ref: DynamicDialogRef, private config: DynamicDialogConfig, private tenantService: TenantService) {
    this.tenantForm = this.initForm();
  }

  static readonly DIALOG_CONFIG: DynamicDialogConfig = {
    header: 'Dati Azienda',
    width: '95vw',
    style: {'max-width': '800px'},
    modal: true,
    focusOnShow: false,
  };

  tenantForm: FormGroup;
  canUploadLogo: boolean = false;

  private initForm(): FormGroup {
    return this.fb.group({
      logoMediaUrl: [null],
      companyName: ['', Validators.required],
      email: ['', Validators.required],
      vatNumber: ['', Validators.required],
      address: ['', Validators.required],
      metaAppId: ['', Validators.required],
      metaWaBusinessAccountId: ['', Validators.required],
      metaWaPhoneNumberId: ['', Validators.required],
      metaWaPhoneNumber: ['', Validators.required],
      metaAuthToken: ['', Validators.required],
    });
  }

  ngOnInit() {
    if(this.config.data){
      this.canUploadLogo = true;
      this.tenantForm.patchValue({...this.config.data})
    }
  }

  save() {
    let tenantToSave = { ...this.tenantForm.value };

    delete tenantToSave.logoMediaUrl;

    this.ref.close({
      action: DialogAction.OK,
      data: tenantToSave
    });
  }

  onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      const file = input.files[0];

      // Preview immediata
      const reader = new FileReader();
      reader.onload = () => {
        this.tenantForm.patchValue({ logoMediaUrl: reader.result as string });
      };
      reader.readAsDataURL(file);

      // Upload al backend
      this.uploadLogo(file);
    }
  }

  uploadLogo(file: File) {
    const formData = new FormData();
    formData.append('file', file);
    this.tenantService.upload(this.config.data.id, formData).subscribe({
      next: (url: string) => {
        // Aggiorna il form con l'URL reale dal backend
        this.tenantForm.patchValue({ logoMediaUrl: url });
      },
      error: (err) => {
        console.error('Errore upload logo', err);
      }
    });
  }

  closeDialog(){
    this.ref.close({
      action: DialogAction.CLOSE,
    });
  }

  ngOnDestroy() {
    if (this.ref) {
      this.ref.close();
    }
  }

  protected readonly date = date;
}
